module.exports = __webpack_public_path__ + "static/assets/922310d46a823ad4a24968f5a8ab1fdc.png";